// Shim de `firebase/messaging` — désactivé (pas de push Firebase).
// Le push reviendra éventuellement via Web Push (VAPID) côté serveur.

export function getMessaging() { return null; }
export async function getToken() { return null; }
export function onMessage() { return () => {}; }

export default { getMessaging, getToken, onMessage };
